/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import { truncate } from 'lodash';
import { connect } from 'react-redux';
import { Avatar, Popover } from 'antd';
import IntlMessages from 'util/IntlMessages';
import { logOut } from 'util/Common';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
// import { getCookieValue, setCookieValue } from 'src/util/Common';

class UserInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const userMenuOptions = (
      <ul className="gx-user-popover">
        <li>
          <Link to={{ pathname: '/user/ho-so' }}>
            <IntlMessages id="app.userAuth.myAccount" />
          </Link>
        </li>
        <li onClick={() => logOut()}><IntlMessages id="app.userAuth.logOut" /></li>
      </ul>
    );
    const { userInfo, isDesktop } = this.props;
    const user = userInfo ? userInfo.user : {};
    return (
      <div className="gx-flex-row gx-align-items-center gx-avatar-row">
        <Popover content={userMenuOptions} placement="bottomRight" trigger="click">
          {isDesktop
            && (
              <Avatar
                alt=""
                className="gx-size-40 gx-pointer gx-mr-3"
                src={user ? user.avatar : 'https://via.placeholder.com/150x150'}
              />
            )}
          <span className="gx-avatar-name">{user ? truncate(user.hoVaTen, { length: 30, separator: ' ' }) : 'No name'}<i
            className="icon icon-chevron-down gx-fs-xxs gx-ml-2"
          />
          </span>
        </Popover>
      </div>
    );
  }
}

UserInfo.propTypes = {
  userInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  isDesktop: PropTypes.bool.isRequired
};

export default connect(null, {})(UserInfo);
